export const tourGuideSteps = [
  {
    selector: "#license-details-header",
    content:
      "This area shows the summary of the Client information. ",
  },
  {
    selector: "#license-data-grid",
    content:
      "This grid contains Mirth Connect Licenses that are registered to your organization.",
  },
  {
    selector: "#view-details-column",
    content:
      "You can click the View Details button below to see the actual license key name and value.",
  },
  {
    selector: "#entitlement-data-grid",
    content:
      "This data shows the Mirth Command Center Entitlements your organization is allowed to leverage. The allotments column lets you know how many instances of this entitlement type you are able to allocate. The amount used is as expected how many are actively being used.",
  },
  {
    selector: "#entitlement-usage-data-grid",
    content:
      "The entitlement usage grid shows where the various entitlements are being used. This will always include the entitlement type, the Client Environment name which is the Mirth Connect Instance, and the Mirth Connect channel name where the entitlement is allocated.",
  },
];

export const licenseKeyModalWithoutKeySteps = [
  {
    selector: "#retrieve-license-key-button",
    content:
      "This button with get the license key.",
  },
];

export const licenseKeyModalWithKeySteps = [
  {
    selector: "#retrieve-license-key-button",
    content:
      "This button with get the license key.",
  },
  {
    selector: "#license-key-text-box",
    content:
      "This text box contains the license key.",
  },
  {
    selector: "#license-key-copy-button",
    content:
      "This button will copy the license key to the clipboard.",
  },
];
